<template>
    <div class="uk-padding uk-background-muted">
        <h1 class="uk-heading-line uk-text-center">Industries Served</h1>
        <div class="uk-container uk-container-small">
            <br><br>
            <div class="uk-child-width-1-3@m" uk-grid>
                <div>
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-media-top">
                            <img src="../../../../public/GABpicture2.jpg" alt="">
                        </div>
                        <div class="uk-card-body uk-padding-small" >
                            <h3 class="uk-card-title h2Style">Public Sector</h3><br>
                            <router-link to="/public-sector-financial-services" class="uk-button uk-button-secondary uk-button-small uk-text-capitalize uk-align-right">Learn More</router-link>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-media-top">
                            <img src="@/assets/form_bg.png" alt="">
                        </div>
                        <div class="uk-card-body uk-padding-small">
                            <h3 class="uk-card-title h2Style">Private Businesses and individuals <br></h3>

                            <router-link to="/private-business-and-individual-financial-services" class="uk-button uk-button-secondary uk-button-small uk-text-capitalize uk-align-right">Learn More</router-link>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-media-top">
                            <img src="../../../../public/i3.png" alt="">
                        </div>
                        <div class="uk-card-body uk-padding-small">
                            <h3 class="uk-card-title h2Style">Charities and Non-Profits</h3>
                            <router-link to="/charities-and-non-profit-financial-services" class="uk-button uk-button-secondary uk-button-small uk-text-capitalize uk-align-right">Learn More</router-link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "industryServe"
    }
</script>

<style scoped>
    .h2Style{
        font-family: 'Overlock SC';
    }
</style>